/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-25 14:58:45
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 15:29:21
 */

import SHA1 from 'js-sha1'
import qs from 'qs';
const sign = (params, noSignAttr = []) => {
  delete params.sign
  var objStr = qs.stringify(params, { arrayFormat: 'indices', encode: false, allowDots: true })
  var objVal = objStr.split('&')
  var realObj = {}
  var appSecret = window.vm.$config.appSecret
  objVal.forEach(item => {
    const [key,value] = item.split('=')
    realObj[key] = value
  })
  const keys = Object.keys(realObj).sort()
  var str = []
  var obj = null
  for (const key in realObj) {
    obj = realObj[key]
    if (obj === null) {
      obj = ''
    } else if (typeof obj === 'object') {
      obj = JSON.stringify(obj)
    }
    realObj[key] = obj
  }
  keys.forEach(e => {
    !noSignAttr.includes(e) && str.push(e + realObj[e])
  })
  realObj.sign = SHA1(appSecret + str.join('') + appSecret).toUpperCase()
  return qs.stringify(realObj)
}
export default sign
